export const BAD_EMAIL = 'bad-email';
